export default [
    {
      id: 1,
      slug: 'kata-pengantar',
      word_limits: 0,
      page_limits: 0,
      rules: [],
      content: `<p>
      Puji syukur kami panjatkan ke hadirat Allah SWT, Tuhan Yang Maha Esa, karena atas rahmat dan hidayah-Nya Lembaga Akreditasi Mandiri Kependidikan (LAMDIK) dapat menyelesaikan format Laporan Evaluasi Diri (LED) untuk Program Sarjana (S1), yang merupakan bagian dari instrumen akreditasi Program Studi (IAPS). IAPS disusun untuk merespons Peraturan Badan Akreditasi Nasional Perguruan Tinggi (BAN PT) Nomor 9 Tahun 2020, tanggal 22 Oktober 2020, tentang Kebijakan Pengalihan Akreditasi Program Studi dari BAN PT ke LAM. LAM dianggap siap melaksanakan akreditasi Program Studi (APS) antara lain apabila LAM telah mempunyai instrumen APS, termasuk instrumen pemenuhan syarat minimum APS, yang telah ditetapkan BAN-PT (Pasal 1 Ayat 1 Huruf c).
  </p>
  <p>
      LED ini terdiri atas tiga bagian, yaitu Profil Unit Pengelola Program Studi (UPPS), Kriteria, dan Analisis Permasalahan dan Pengembangan Program Studi (PS). Profil UPPS berisi 10 aspek, yaitu (1) identitas; (2) visi, misi, tujuan, dan strategi pencapaiannya (VMTS); (3) dosen; (4) mahasiswa; (5) keuangan; (6) sarana dan prasarana pembelajaran; (7) kerja sama yang relevan; (8) Sistem Penjaminan Mutu Internal (SPMI); (9) unggulan; dan (10) posisi daya saing UPPS. Kriteria terdiri atas (1) visi, misi, tujuan, dan strategi; (2) tata pamong, tata kelola, dan kerja sama; (3) mahasiswa; (4) sumber daya manusia; (5) keuangan, sarana, dan prasarana; (6) pendidikan; (7) penelitian; (8) pengabdian kepada masyarakat; dan (9) keluaran dan capaian tridharma. Analisis Permasalahan dan Pengembangan PS dibagi menjadi tiga kelompok, yaitu (1) evaluasi capaian kinerja PS, (2) permasalahan dan pemecahan praktis, dan (3) program pengembangan.
  </p>
  <p>
      Setiap Kriteria (Bagian B) dielaborasi menjadi empat aspek, yaitu (1) kebijakan, yang merupakan standar yang ditetapkan oleh perguruan tinggi, selain standar yang ditetapkan oleh Pemerintah melalui SN-Dikti, (2) pelaksanaan, (3) evaluasi, dan (4) tindak lanjut. Aspek Evaluasi menjawab sejumlah pertanyaan, seperti “Apakah PS dan UPPS telah mampu mencapai standar yang ditetapkan oleh Pemerintah melalui Standar Nasional Pendidikan Tinggi (SN-Dikti) dan standar yang ditetapkan oleh perguruan tinggi?” “Apabila sudah, sebaik atau setinggi apa PS dan UPPS mencapai standar tersebut?” “Apabila belum, faktor-faktor apa yang menyebabkan PS dan UPPS belum mampu mencapai standar tersebut?” Aspek Tindak Lanjut mengemukakan langkah-langkah yang diambil, berdasarkan hasil evaluasi, agar PS dan UPPS mampu mencapai atau melampaui standar nasional dan standar lokal yang ditetapkan oleh perguruan tinggi. Dengan demikian, upaya BUKU 2 LAPORAN EVALUASI DIRI Hal. iii peningkatan mutu secara berkelanjutan dalam rangka membangun budaya mutu dapat segera terwujud.
  </p>`
    },
    {
      id: 2,
      slug: 'bagian-a-profil-unit-pengelola-program-studi',
      word_limits: 5000,
      page_limits: 0,
      rules: [
          'Uraikan profil UPPS yang meliputi 10 aspek tersebut dalam bentuk.',
          '(1) esai naratif dan',
          '(2) tabel- tabel sederhana dalam jumlah kata paling banyak 5.000 kata. ',
          '(3) Maksimal 10 halaman '
      ],
      content: `<h2 style="text-align:center;">
      <strong>BAGIAN A</strong>
  </h2>
  <h2 style="text-align:center;">
      <strong>PROFIL UNIT PENGELOLA PROGRAM STUDI</strong>
  </h2>
  <p style="text-align:center;">
      &nbsp;
  </p>
  <p>
      Profil Unit Pengelola Program Studi (UPPS) berisi deskripsi singkat mengenai eksistensi, kelebihan, dan posisi strategis UPPS di dalam dan di luar perguruan tinggi. Profil tersebut meliputi 10 aspek, yaitu (1) identitas: nama, tahun berdiri, nomor Surat Keputusan (SK), jumlah program studi (PS) program sarjana, alamat, nomor telepon, alamat email kelembagaan, dan website resmi lembaga; (2) visi, misi, tujuan, dan strategi pencapaian visi, misi, dan tujuan tersebut (VMTS); (3) dosen: jumlah dosen tetap (DT); kualifikasi akademik, jabatan fungsional, dan sertifikat pendidik DT; dan rasio DT terhadap mahasiswa reguler; (4) mahasiswa: jumlah mahasiswa regular, rata-rata Indeks Prestasi Kumulatif (IPK) lulusan, rata-rata masa studi; (5) keuangan: besar dana yang diperoleh dan dikelola, dana operasional per mahasiswa/tahun, dana operasional pendidikan, dana penelitian, dana pengabdian kepada masyarakat (PkM), dana publikasi, dan dana investasi; (6) sarana dan prasarana pembelajaran: jenis, jumlah, dan kualitas; (7) kerja sama yang relevan: jumlah kerja sama dalam negeri dan jumlah kerja sama luar negeri; (8) Sistem Penjaminan Mutu Internal (SPMI): kebijakan, dokumen, pelaksanaan, dan laporan SPMI sesuai siklus PPEPP; (9) unggulan: unggulan dalam bidang Pendidikan yang mencerminkan pembeda, unggulan dalam bidang penelitian, unggulan dalam bidang PkM, unggulan dalam bidang publikasi, dan unggulan dalam bidang pengembangan kelembagaan Pendidikan secara berkelanjutan; dan (10) posisi daya saing UPPS di tingkat nasional, yaitu status akreditasi Perguruan Tinggi.
  </p>`
    },
    {
      id: 3,
      slug: 'bagian-b-kriteria',
      word_limits: 0,
      page_limits: 180,
      has_children: true,
      rules: [
          'keseluruhan kriteria (BAGIAN B KRITERIA) maksimal 180 halaman'
      ],
      content: `<h2 style="text-align:center;">
      <strong>BAGIAN B</strong>
  </h2>
  <h2 style="text-align:center;">
      <strong>KRITERIA</strong>
  </h2><p style="text-align:center;">
  &nbsp;
  </p><p>
      Bagian ini berisi sembilan kriteria yang meliputi (1) Visi, Misi, Tujuan, dan Strategi; (2) Tata Pamong,&nbsp; &nbsp;Tata Kelola, dan Kerjasama; (3) Mahasiswa; (4) Sumber Daya Manusia; (5) Keuangan, Sarana dan&nbsp; &nbsp;Prasarana; (6) Pendidikan; (7) Penelitian; (8) Pengabdian kepada Masyarakat; dan (9) Keluaran dan&nbsp; Capaian Tridharma.
  </p>`
    },
    {
      id: 4,
      parent_id: 3,
      slug: 'kriteria-1-visi-misi-tujuan-dan-strategi-vmts',
      word_limits: 0,
      page_limits: 0,
      rules: [
          'keseluruhan kriteria (BAGIAN B KRITERIA) maksimal 180 halaman'
      ],
      content: `<p>
      <strong>KRITERIA 1. VISI, MISI, TUJUAN, DAN STRATEGI (VMTS)</strong>
  </p><p>
      Visi adalah cita-cita besar lembaga yang diakreditasi. Misi adalah tugas yang harus dikerjakan&nbsp; dalam upaya mewujudkan visi yang telah dibuat. Tujuan adalah penjabaran visi dan misi, dan&nbsp; merupakan hal yang harus dicapai atau dihasilkan oleh lembaga; dan oleh karena itu bersifat lebih&nbsp; spesifik dan terukur. Strategi adalah tindakan atau kegiatan yang dilakukan oleh lembaga untuk&nbsp; mencapai tujuan yang telah ditetapkan.
  </p>
  <p>
      <strong>1.1 Kebijakan&nbsp;</strong>&nbsp;
      <br>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang,&nbsp; Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan&nbsp; tinggi (Rektor, Direktur, atau Ketua) yang mengatur penyusunan, sosialisasi, implementasi, dan&nbsp; evaluasi visi keilmuan dan tujuan PS (Tujuan PS adalah menghasilkan lulusan yang sesuai dengan&nbsp; profil lulusan PS).
  </p>
  <p>
      <strong>1.2 Pelaksanaan&nbsp;</strong>&nbsp;
      <br>
      <strong>1.2.1 Mekanisme Penyusunan Visi Keilmuan dan Tujuan PS</strong>&nbsp;
      <br>
      Deskripsikan mekanisme penyusunan visi keilmuan PS dan tujuan PS, yang melibatkan para pihak,&nbsp; baik di internal maupun eksternal PS dan UPPS.
  </p>
  <p>
      <strong>1.2.2 Rumusan Visi Keilmuan</strong>&nbsp;
      <br>
      Tuliskan rumusan (1) visi keilmuan PS, (2) tujuan PS, dan (3) strategi pencapaian tujuan PS tersebut&nbsp; (dalam bentuk rumusan Capaian Pembelajaran Lulusan atau CPL), dan (4) Keselarasan rumusan&nbsp; visi keilmuan PS dengan visi kelembagaan UPPS dan PT.
  </p>
  <p>
      <strong>1.2.3 Tingkat Pemahaman Visi Keilmuan dan Tujuan PS</strong>&nbsp;
      <br>
      Uraikan tingkat pemahaman sivitas akademika PS terhadap visi keilmuan PS, tujuan PS, dan&nbsp; strategi pencapaian tujuan PS, yang diperoleh dari hasil survey terhadap dosen, tenaga&nbsp; kependidikan, dan mahasiswa di PS.
  </p>
  <p>
      <strong>1.3 Evaluasi</strong>&nbsp;
      <br>
      Tuliskan hasil evaluasi terhadap (1) kebijakan, (2) rumusan, dan (3) tingkat pemahaman visi&nbsp; &nbsp;keilmuan PS, tujuan PS, strategi pencapaian tujuan PS. Evaluasi tentang rumusan difokuskan pada&nbsp; (1) kejelasan dan kerealistikan visi keilmuan PS, tujuan PS, dan strategi pencapaian tujuan PS, dan&nbsp; &nbsp;(2) keselarasan visi keilmuan PS, tujuan PS, dan strategi pencapaian tujuan PS dengan VMTS &nbsp;UPPS dan PT.
  </p>
  <p>
      <strong>1.4 Tindak Lanjut</strong>&nbsp;
      <br>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 1.3, jelaskan tindak lanjut yang telah&nbsp; diambil oleh UPPS dalam rangka meningkatkan (1) kejelasan dan kerealistikan visi keilmuan PS,&nbsp; tujuan PS, dan strategi pencapaian tujuan PS, (2) keselarasan visi keilmuan PS, tujuan PS, dan&nbsp; strategi pencapaian tujuan PS dengan VMTS UPPS, dan (4) tingkat pemahaman sivitas akademika&nbsp; terhadap visi keilmuan PS, tujuan PS, dan strategi pencapaian tujuan PS
  </p>`
    },
    {
      id: 5,
      parent_id: 3,
      slug: 'kriteria-2-tata-pamong-tata-kelola-dan-kerja-sama',
      word_limits: 0,
      page_limits: 0,
      rules: [
          'keseluruhan kriteria (BAGIAN B KRITERIA) maksimal 180 halaman'
      ],
      content: `<p>
      <strong>KRITERIA 2. TATA PAMONG, TATA KELOLA, DAN KERJA SAMA</strong>
  </p><p>
      <strong>2.1 Tata Pamong, Tata Kelola, dan Kepemimpinan&nbsp;</strong>
  </p>
  <p>
      Tata pamong adalah suatu sistem yang memungkinkan kepemimpinan, sistem pengelolaan, dan penjaminan mutu berjalan secara efektif di suatu lembaga; dan memenuhi lima kriteria, yaitu kredibel, transparan, akuntabel, bertanggung jawab, dan adil. Tata pamong yang kredibel adalah tata pamong yang dapat dipercaya karena didasarkan pada kebijakan dan peraturan yang telah ditetapkan. Transparansi merujuk pada prinsip yang menjamin keterbukaan pengelolaan program studi yang memungkinkan kemudahan untuk diakses oleh pihak-pihak yang berkepentingan. Tata pamong yang akuntabel adalah tata pamong yang dapat dipertanggungjawabkan. Tata pamong yang bertanggung jawab adalah tata pamong yang menjamin ketercapaian visi, misi, dan tujuan. Tata pamong yang adil adalah tata pamong yang menjamin perlakuan yang proporsional bagi sivitas akademika sesuai dengan tugas pokok serta fungsi masing-masing. Tata kelola merujuk pada kebijakan tertulis dan realisasinya yang memungkinkan UPPS menjalankan pengelolaan yang baik dan efektif, yang tercermin dari adanya kegiatan perencanaan, pengorganisasian, pemilihan dan penempatan personel, pelaksanaan, pemantauan dan pengawasan, pengendalian, penilaian, pelaporan, dan pengembangan sebagai wujud tindak lanjut. Kepemimpinan adalah kemampuan yang dimiliki seseorang untuk mempengaruhi, mengarahkan, dan memandu pihak tertentu untuk mencapai tujuan. Dari segi fungsi, kepemimpinan meliputi kepemimpinan operasional, kepemimpinan organisasi, dan kepemimpinan publik. Kepemimpinan operasional merujuk pada kemampuan Ketua/Kepala UPPS menjabarkan visi dan misi ke dalam program kerja jangka pendek, menengah, dan panjang secara jelas dan terukur. Kepemimpinan organisasi berkaitan dengan kemampuan menggerakkan semua potensi yang ada untuk menjalankan program kerja yang telah ditetapkan, mulai dari perencanaan, pelaksanaan, evaluasi, dan tindak lanjut. Kepemimpinan publik berkaitan dengan kemampuan menggerakkan UPPS menjalin kerja sama dengan pihak lain, baik di tingkat nasional maupun internasional untuk mendukung percepatan kemajuan dan keunggulan UPPS dan perguruan tinggi. Kepemimpinan publik juga ditunjukkan oleh peran pengelola UPPS yang dimiliki dalam masyarakat, baik di tingkat nasional dan daerah, khususnya bidang kependidikan.&nbsp;
  </p>
  <p>
      &nbsp;
  </p>
  <p>
      <strong>2.1.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur tata pamong, tata kelola, dan kepemimpinan di UPPS. 5&nbsp;
  </p>
  <p>
      <strong>2.1.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      <strong>2.1.2.1 Tata Pamong&nbsp;</strong>
  </p>
  <p>
      Uraikan sistem dan perwujudan good governance di UPPS dengan struktur organisasi dan tata pamong yang lengkap, fungsional, dan disertai dengan tugas pokok dan fungsi (tupoksi) masingmasing secara jelas, serta memenuhi lima pilar: (1) kredibel, (2) transparan, (3) akuntabel, (4) bertanggung jawab, dan (5) adil.
  </p>
  <p>
      <strong>&nbsp;2.1.2.2 Tata Kelola&nbsp;</strong>
  </p>
  <p>
      Uraikan sistem dan pelaksanaan tata kelola di UPPS yang menggambarkan adanya (1) perencanaan, (2) pengorganisasian, (3) pemilihan dan penempatan personel, (4) pelaksanaan, (5) pemantauan dan pengawasan, (6) pengendalian, (7) penilaian, (8) pelaporan, dan (9) pengembangan sebagai wujud tindak lanjut evaluasi tatakelola secara periodik.&nbsp;
  </p>
  <p>
      <strong>2.1.2.3 Kepemimpinan</strong>
  </p>
  <p>
      &nbsp;Jelaskan operasionalisasi dan implementasi kepemimpinan di UPPS, yang meliputi (1) kepemimpinan operasional, (2) kepemimpinan organisasi, dan (3) kepemimpinan publik, baik di tingkat daerah/wilayah, tingkat nasional maupun tingkat internasiona, khususnya dalam bidang kependidikan.&nbsp;
  </p>
  <p>
      <strong>2.1.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan perwujuan tata pamong, tata kelola, dan kepemimpinan di UPPS. Pelaksanaan tata pamong tercermin dari aspek (1) keberadaan dan kelengkapan struktur organisasi, (2) deskripsi pekerjaan (job description) yang jelas, dan (3) pemenuhan prinsip kredibilitas, transparansi, akuntabilitas, tanggung jawab, dan adil. Pelaksanaan tata kelola tercermin dari adanya (1) perencanaan, (2) pengorganisasian, (3) pemilhan dan penempatan personel, (4) pelaksanaan, (5) pemantauan dan pengawasan, (6) pengendalian, (7) penilaian, (8) pelaporan, dan (9) pengembangan sebagai wujud tindak lanjut. Operasionalisasi dan implementasi kepemimpinan di UPPS meliputi (1) kepemimpinan operasional, (2) kepemimpinan organisasi, dan (3) kepemimpinan publik, baik di tingkat daerah/wilayah, tingkat nasional maupun tingkat internasional, khususnya dalam bidang kependidikan.&nbsp;
  </p>
  <p>
      <strong>2.1.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 2.1.3, jelaskan tindak lanjut yang telah diambil untuk meningkatkan kualitas tata kelola, tata pamong, dan kepemimpinan di UPPS. 6&nbsp;
  </p>
  <p>
      <strong>2.2 Kerja Sama</strong>
  </p>
  <p>
      &nbsp;Kerja sama merujuk pada usaha yang dilakukan dengan para pihak secara bersama-sama untuk mencapai tujuan bersama dan memperoleh hasil yang dapat dinikmati bersama. Kerja sama dapat dilakukan oleh UPPS dengan pihak lain di dalam perguruan tinggi yang sama, dengan pihak lain di luar perguruan tinggi di dalam negeri, dan dengan pihak lain di luar negeri. Kerja sama yang dilakukan oleh UPPS hendaknya memberikan manfaat bagi UPPS dalam pemenuhan tridharma, mendukung peningkatan kinerja tridharma dan fasilitas pembelajaran di UPPS, serta memberikan kepuasan kepada para pihak.&nbsp;
  </p>
  <p>
      <strong>2.2.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur kerja sama di UPPS.&nbsp;
  </p>
  <p>
      <strong>2.2.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      Tuliskan data kerja sama dalam bidang tridharma PT di UPPS yang meliputi nama lembaga mitra, tingkat, judul dan ruang lingkup, manfaat/output, durasi dan waktu dalam tiga tahun terakhir dengan mengikuti format Tabel 2.2.2
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 2.2.2 Data Kerja Sama]</u></strong></i>
  </p>
  <p>
      &nbsp;
  </p>
  <p>
      <strong>2.2.3 Evaluasi</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pelaksanaan kerja sama di UPPS. Pelaksanaan kerja sama meliputi data tentang nama lembaga mitra, tingkat, judul dan ruang lingkup, manfaat/output, durasi dan waktu kerja sama. Pelaksanaan penjaminan mutu meliputi PPEPP dan bukti keefektifan pelaksanaan penjaminan mutu.
  </p>
  <p>
      <strong>2.2.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 2.2.3, jelaskan tindak lanjut yang telah diambil untuk meningkatkan jumlah dan kualitas kerja sama di UPPS.&nbsp;
  </p>
  <p>
      <strong>2.3 Penjaminan Mutu&nbsp;</strong>
  </p>
  <p>
      <strong>2.3.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur penjaminan mutu di PT dan/atau di UPPS.&nbsp;
  </p>
  <p>
      <strong>2.3.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      Uraikan pelaksanaan penjaminan mutu di PS yang merefleksikan perwujudan dari kebijakan penjaminan mutu yang telah ditetapkan oleh PT, yang menunjukkan adanya unit/gugus penjaminan mutu, terlaksananya siklus PPEPP, tersedianya dokumentasi pelaksanaan penjaminan mutu, dan pelaksanaan external benchmarking penjaminan mutu.&nbsp;
  </p>
  <p>
      <strong>2.3.3 Evaluasi</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pelaksanaan penjaminan mutu yang dilaksanakan di PS.&nbsp;
  </p>
  <p>
      <strong>2.3.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 2.3.3, jelaskan tindak lanjut yang telah diambil untuk meningkatkan kualitas pelaksanaan penjaminan mutu di PS.
  </p>`
    },
    {
      id: 6,
      parent_id: 3,
      slug: 'kriteria-3-mahasiswa',
      word_limits: 0,
      page_limits: 0,
      rules: [
          'keseluruhan kriteria (BAGIAN B KRITERIA) maksimal 180 halaman'
      ],
      content: `<p>
      <strong>KRITERIA 3. MAHASISWA</strong>
  </p><p>
      <strong>3.1 Rekrutmen dan Tes Seleksi Mahasiswa Baru</strong>
  </p>
  <p>
      <strong>3.1.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur rekrutmen dan seleksi mahasiswa baru, kualitas input calon mahasiswa baru, dan daerah asal calon mahasiswa baru di PS.
  </p>
  <p>
      <strong>3.1.2 Pelaksanaan</strong>
  </p>
  <p>
      <strong>3.1.2.1 Rekrutmen dan Tes Seleksi Mahasiswa Baru</strong>
  </p>
  <p>
      Uraikan pelaksanaan rekrutmen dan tes seleksi mahasiswa baru, termasuk tes minat/bakat dalam bidang kependidikan dan menjadi calon pendidik, sebagai pembeda dari program studi nonkependidikan.
  </p>
  <p>
      <strong>3.1.2.2 Kualitas Input Calon Mahasiswa Baru</strong>
  </p>
  <p>
      Tuliskan data mahasiswa reguler PS dalam lima tahun terakhir dengan mengikuti format Tabel 3.1.2.2
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 3.1.2.2 Mahasiswa Reguler]</u></strong></i>
  </p>
  <p>
      <i><strong><u>3.1.2.3 Daerah Asal Calon Mahasiswa Baru&nbsp;</u></strong></i>
  </p>
  <p>
      Tuliskan data calon mahasiswa reguler PS yang diakreditasi dalam lima tahun terakhir dengan mengikuti format Tabel 3.1.2.3.1 dan Tabel 3.1.2.3.2.
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 3.1.2.3.1 Calon Mahasiswa Dalam Negeri]</u></strong></i>
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 3.1.2.3.2 Calon Mahasiswa Luar Negeri]</u></strong></i>
  </p>
  <p>
      <strong>3.1.3 Evaluasi</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pelaksanaan rekrutmen dan seleksi mahasiswa baru, kualitas input calon mahasiswa baru, dan daerah asal calon mahasiswa baru di PS.
  </p>
  <p>
      <strong>3.1.4 Tindak Lanjut</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 3.1.3, jelaskan tindak lanjut yang telah diambil dalam rangka meningkatkan jumlah dan kualitas calon mahasiswa baru, baik dari dalam negeri maupun dari luar negeri.
  </p>
  <p>
      <strong>3.2 Program Layanan dan Pembinaan Mahasiswa&nbsp;</strong>
  </p>
  <p>
      <strong>3.2.1 Kebijakan</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur program layanan dan pembinaan mahasiswa dalam bidang minat, bakat, penalaran, kesejahteraan, dan keprofesian.
  </p>
  <p>
      <strong>3.2.2 Pelaksanaan</strong>
  </p>
  <p>
      Tuliskan ketersediaan dan pelaksanaan program layanan dan pembinaan minat, bakat, penalaran, kesejahteraan, dan keprofesian mahasiswa dalam lima tahun terakhir pada Tabel 3.2.2
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 3.2.2 Program layanan dan pembinaan minat, bakat, penalaran, kesejahteraan, dan keprofesian mahasiswa]</u></strong></i>
  </p>
  <p>
      <strong>3.2.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pelaksanaan program layanan dan pembinaan minat, bakat, penalaran, kesejahteraan, dan keprofesian mahasiswa.
  </p>
  <p>
      <strong>3.2.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pelaksanaan program layanan dan pembinaan minat, bakat, penalaran, kesejahteraan, dan keprofesian mahasiswa.
  </p>`
    },
    {
      id: 7,
      parent_id: 3,
      slug: 'kriteria-4-sumber-daya-manusia',
      word_limits: 0,
      page_limits: 0,
      rules: [
          'keseluruhan kriteria (BAGIAN B KRITERIA) maksimal 180 halaman'
      ],
      content: `<p>
      <strong>KRITERIA 4. SUMBER DAYA MANUSIA</strong>
  </p><p>
      <strong>4.1 Dosen Dosen&nbsp;</strong>
  </p>
  <p>
      dikelompokkan menjadi dosen tetap dan dosen tidak tetap. Dosen tetap (DT) UPPS adalah dosen yang bekerja penuh waktu di PT sebagai satuan administrasi pangkalnya dan tidak sedang menjadi pegawai tetap di satuan administrasi pangkal yang lain. DT dibagi menjadi dua kelompok, yaitu DT yang bidang keahliannya sesuai dengan bidang keahlian PS dan DT yang bidang keahliannya berada di luar keahlian bidang PS. DTPS kategori pertama biasanya mengajar mata kuliah inti PS (dan mendapatkan SK pengangkatan sebagai dosen tetap di PS tersebut), sedangkan DTPS kategori kedua biasanya mengajar mata kuliah di luar inti mata kuliah PS, seperti mata kuliah wajib perguruan tinggi (seperti mata kuliah umum) dan mata kuliah wajib fakultas (seperti mata kuliah kependidikan). 4.1.1 Kebijakan&nbsp;
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur rekrutmen dan seleksi, penempatan, pengembangan, evaluasi kinerja, dan pemberhentian dosen di PT dan UPPS.&nbsp;
  </p>
  <p>
      <strong>4.1.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      <strong>4.1.2.1 Rekrutmen dan Tes Seleksi Dosen&nbsp;</strong>
  </p>
  <p>
      Deskripsikan pelaksanaan rekrutmen dan tes seleksi dosen di PT dan UPPS baik dosen tetap (PNS atau yayasan) maupun dosen tidak tetap.&nbsp;
  </p>
  <p>
      <strong>4.1.2.2 Profil DTPS yang Bidang Keahliannya Sesuai Bidang PS&nbsp;</strong>
  </p>
  <p>
      Tuliskan profil DTPS yang bidang keahliannya sesuai dengan bidang PS dalam Tabel 4.1.2.2, yang mencakup (1) nama lengkap, (2) nomor induk dosen nasional (NIDN) atau Nomor Induk Dosen Khusus (NIDK), (3) tanggal lahir, (4) sertifikat pendidik, (5) jabatan fungsional, (6) gelar akademik, (7) pendidikan S-1, S-2, S-3 dan asal PT, dan (8) bidang keahlian untuk setiap jenjang pendidikan.&nbsp;
  </p>
  <p>
      <strong>4.1.2.3 Profil DTPS yang Bidang Keahliannya di Luar Bidang PS&nbsp;</strong>
  </p>
  <p>
      Tuliskan profil DTPS yang bidang keahliannya di luar bidang PS dalam tabel 4.1.2.3, yang mencakup (1) nama lengkap, (2) nomor induk dosen nasional atau NIDN atau Nomor Induk Dosen Khusus (NIDK), (3) tanggal lahir, (4) sertifikat pendidik, (5) jabatan fungsional, (6) gelar akademik, (7) pendidikan S1, S2, S3 dan asal PT, dan (8) bidang keahlian untuk setiap jenjang pendidikan.
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 4.1.2.2 DTPS yang Bidang Keahliannya Sesuai dengan Bidang PS]</u></strong></i>
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 4.1.2.3 DTPS yang Bidang Keahliannya di Luar Bidang PS]</u></strong></i>
  </p>
  <p>
      <strong>4.1.2.4 Rasio DTPS terhadap Mahasiswa Reguler</strong>
  </p>
  <p>
      Tuliskan rasio jumlah DTPS yang bidang keahliannya sesuai dengan bidang PS terhadap jumlah mahasiswa reguler dengan mengikuti format Tabel 4.1.2.4.
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 4.1.2.4 Rasio DTPS terhadap Mahasiswa Reguler]</u></strong></i>
  </p>
  <p>
      <strong>4.1.2.5 Beban Kerja Dosen Tetap</strong>
  </p>
  <p>
      Beban kerja mencakup kegiatan tridharma (pembelajaran, penelitian, dan pengabdian kepada masyarakat/PkM) dan kegiatan manajemen bagi yang menduduki jabatan tertentu (yaitu Rektor, Wakil Rektor, Dekan, Wakil Dekan, Ketua Lembaga, Sekretaris Lembaga, Kepala Program Studi, Sekretaris Program Studi, Kepala UPT, dan lain-lain). Beban kerja tersebut dituangkan dalam bentuk satuan kredit semester (sks). Dosen tetap di sini adalah DTPS yang keahliannya sesuai dengan bidang PS.
  </p>
  <p>
      Tuliskan kegiatan tridharma PT dan manajemen DTPS yang bidang keahliannya sesuai dengan PS di tahun akademik terakhir (TS), dengan mengikuti format Tabel 4.1.2.5.
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 4.1.2.5 Beban Kerja Dosen DTPS]</u></strong></i>
  </p>
  <p>
      <strong>4.1.2.6 Kegiatan Mengajar Dosen Tetap</strong>
  </p>
  <p>
      Tuliskan kegiatan mengajar DTPS yang bidang keahliannya sesuai dengan PS di tahun akademik terakhir (TS), dengan mengikuti format Tabel 4.1.2.6.
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 4.1.2.6 Kegiatan Mengajar Dosen Tetap]</u></strong></i>
  </p>
  <p>
      <strong>4.1.2.7 Jumlah Bimbingan Tugas Akhir atau Skripsi, Tesis, dan Disertasi</strong>
  </p>
  <p>
      Tuliskan jumlah mahasiswa di PS yang tugas akhir (pameran lukisan, pementasan seni, rancangan produk, dll ) atau skripsi/tesis/disertasi-nya dibimbing oleh DTPS yang bidang keahliannya relevan dengan bidang PS dalam tiga tahun terakhir, dengan mengikuti format Tabel 4.1.2.7.
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 4.1.2.7 Jumlah Bimbingan Tugas Akhir atau Skripsi, Tesis, dan Disertasi]</u></strong></i>
  </p>
  <p>
      <strong>4.1.2.8 Prestasi Dosen</strong>
  </p>
  <p>
      Prestasi dosen dapat berupa prestasi sebagai (1) pembicara kunci (keynote speaker) atau pembicara utama (pleanary speaker atau invited speaker) dalam konferensi atau seminar; (2) dosen tamu (visiting scholar/professor) di perguruan tinggi unggul di dalam dan di luar negeri; (3) narasumber dalam lokakarya di perguruan tinggi atau lembaga yang kredibel; (4) konsultan atau tenaga ahli di lembaga atau industri; (5) editor atau mitra bestari dalam jurnal nasional terakreditasi atau jurnal internasional bereputasi; dan lain-lain.
  </p>
  <p>
      Tuliskan prestasi DTPS yang bidang keahliannya sesuai dengan bidang PS dalam tiga tahun terakhir, dengan mengikuti format Tabel 4.1.2.8
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 4.1.2.8 Prestasi DTPS]</u></strong></i>
  </p>
  <p>
      <strong>4.1.2.9 Pengembangan Kompetensi Dosen</strong>
  </p>
  <p>
      Yang dimaksud dengan pengembangan kompetensi dosen adalah segala bentuk kegiatan yang dilakukan oleh DTPS yang bidang keahliannya relevan dengan bidang PS untuk meningkatkan kompetensi dan kariernya. Kegiatan tersebut meliputi kegiatan studi lanjut ke jenjang S3, postdoc, kursus singkat, magang dosen, pelatihan, sertifikasi, konferensi, seminar, lokakarya, dan lain-lain yang relevan dengan tri darma perguruan tinggi dosen kependidikan.
  </p>
  <p>
      Tuliskan kegiatan pengembangan kompetensi dosen, seperti studi lanjut ke jenajang S3, mengikuti postdoc, kursus singkat (short course), magang, pelatihan, sertifikasi, konferensi, seminar, dan lokakarya, dan lain-lain yang relevan dengan tridharma PT yang telah dilakukan oleh DTPS yang bidang keahliannya sesuai dengan bidang PS dalam tiga tahun terakhir, dengan mengikuti format Tabel 4.1.2.9.
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 4.1.2.9 Pengembangan Kompetensi DTPS]</u></strong></i>
  </p>
  <p>
      <strong>4.1.3 Evaluasi</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pelaksanaan rekrutmen, jumlah dan kualitas, dan pengembangan kompetensi dan dosen di PT dan UPPS.
  </p>
  <p>
      <strong>4.1.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 4.1.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan kualitas implementasi kebijakan, pelaksanaan rekrutmen, jumlah dan kualitas, dan pengembangan kompetensi dosen di UPPS.&nbsp;
  </p>
  <p>
      <strong>4.2 Tenaga Kependidikan (Tendik)&nbsp;</strong>
  </p>
  <p>
      Tenaga kependidikan (tendik) adalah SDM yang secara langsung mendukung pelaksanaan kegiatan tridharma PT di UPPS. Tendik tersebut meliputi tenaga administrasi akademik, pustakawan, laboran, dan operator/programmer/teknisi, yang memiliki pendidikan formal atau pelatihan khusus sesuai dengan bidangnya dan dibuktikan dengan kepemilikan ijazah dan/atau sertifikat kompetensi.&nbsp;
  </p>
  <p>
      <strong>4.2.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur rekrutmen dan seleksi, penempatan, pengembangan, evaluasi kinerja, dan pemberhentian tenaga kependidikan di PT dan UPPS.&nbsp;
  </p>
  <p>
      <strong>4.2.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      <strong>4.2.2.1 Rekrutmen dan Tes Seleksi Tendik</strong>
  </p>
  <p>
      Uraikan pelaksanaan rekrutmen dan seleksi tendik, baik tendik tetap (Pegawai Negeri Sipil atau Yayasan) maupun tidak tetap.&nbsp;
  </p>
  <p>
      <strong>4.2.2.2 Profil Tendik&nbsp;</strong>
  </p>
  <p>
      Tuliskan nama tendik yang secara langsung mendukung pelaksanaan kegiatan tridharma PT di UPPS, dengan format Tabel 4.2.2.2.
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 4.2.2.2 Profil Tendik]</u></strong></i>
  </p>
  <p>
      <strong>4.2.2.3 Pengembangan Kompetensi Tendik&nbsp;</strong>
  </p>
  <p>
      Tuliskan kegiatan pengembangan kompetensi (studi lanjut, kursus singkat, magang, pelatihan, sertifikasi, dan lain-lainnya) tendik yang dilakukan dalam tiga tahun terakhir, dengan mengikuti format Tabel 4.2.2.3.
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 4.2.2.3 Pengembangan Kompetensi dan Karier Tendik]</u></strong></i>
  </p>
  <p>
      <strong>4.2.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap Kebijakan dan pelaksanaan rekrutmen, jumlah dan kualitas, dan pengembangan kompetensi tendik di UPPS.
  </p>
  <p>
      <strong>4.2.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 4.2.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan kualitas implementasi kebijakan, pelaksanaan rekrutmen, jumlah dan kualitas, dan pengembangan kompetensi tendik di UPPS.&nbsp;
  </p>
  <p>
      <strong>4.3 Kepuasan dosen dan tenaga kependidikan terhadap manajemen SDM&nbsp;</strong>
  </p>
  <p>
      <strong>4.3.1 Kebijakan</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur kepuasan dosen dan tenaga kependidikan terhadap manajemen SDM.
  </p>
  <p>
      <strong>4.3.2 Pelaksanaan</strong>
  </p>
  <p>
      Uraikan ketersediaan instrumen untuk mengukur tingkat kepuasan dosen dan tenaga kependidikan terhadap manajemen SDM yang meliputi jenis instrumen, pengembang dan validator instrumen, pelaksanaan uji coba intrumen, dan finalisasi instrumen (Tabel 4.3.2), pelaksanaan pengukuran kepuasan dosen (Tabel 4.3.3), dan pelaksanaan pengukuran kepuasan tenaga kependidikan (Tabel 4.3.4).
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 4.3.2 Jenis instrumen yang digunakan untuk mengukur kepuasan dosen dan tenaga kependidikan terhadap manajemen SDM.]</u></strong></i>
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 4.3.3 Pelaksanaan pengukuran kepuasan dosen terhadap manajemen SDM]</u></strong></i>
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 4.3.4 Pelaksanaan pengukuran kepuasan tenaga kependidikan terhadap manajemen SDM]</u></strong></i>
  </p>
  <p>
      <strong>4.3.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pelaksanaan yang mengatur kepuasan dosen dan tenaga kependidikan terhadap manajemen SDM&nbsp;
  </p>
  <p>
      <strong>4.3.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 4.3.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan kualitas kebijakan dan implementasi pengukuran kepuasan dosen dan tenaga kependidikan terhadap manajemen SDM.
  </p>`
    },
    {
      id: 8,
      parent_id: 3,
      slug: 'kriteria-5-keuangan-sarana-dan-prasarana',
      word_limits: 0,
      page_limits: 0,
      rules: [
          'keseluruhan kriteria (BAGIAN B KRITERIA) maksimal 180 halaman'
      ],
      content: `<p>
      <strong>KRITERIA 5. KEUANGAN SARANA DAN PRASARANA</strong>
  </p><p>
      <strong>5.1 Keuangan&nbsp;</strong>
  </p>
  <p>
      Keuangan meliputi dana yang diperoleh dan dikelola oleh UPPS dan penggunaan dana tersebut. Dana yang diperoleh dan dikelola oleh UPPS meliputi dana dari perguruan tinggi sendiri, yayasan, kementerian, lembaga tertentu di dalam negeri (DN) dan/atau luar negeri (LN), dan sumber lain. Penggunaan dana meliputi penggunaan dana operasional untuk kegiatan pendidikan (seperti gaji, honorarium, tunjangan, bahan dan peralatan habis pakai, listrik, air minum, telepon, konsumsi rapat, dan pemeliharaan gedung), penelitian, PkM, publikasi, kemahasiswaan, investasi sumber daya manusia (SDM), dan investasi prasarana dan sarana pendidikan. Dana penelitian adalah dana yang digunakan untuk kegiatan penelitian DTPS yang bidang keahliannya relevan dengan bidang PS dalam tiga tahun terakhir, yang bersumber dari berbagai skema, seperti kementerian, PT sendiri (penerimaan negara bukan pajak atau PNBP), kerja sama dengan pihak lain (Pemerintah Daerah, swasta, lembaga dalam dan luar negeri), atau mandiri. Dana penelitian tidak termasuk dana yang digunakan untuk penyelesaian tugas akhir (tesis dan disertasi) yang merupakan bagian dari penyelesaian studi lanjut. Dana PkM adalah dana yang digunakan untuk kegiatan PkM DTPS yang bidang keahliannya relevan dengan bidang PS dalam tiga tahun terakhir, yang bersumber dari berbagai skema, seperti kementerian, PT sendiri (PNBP), kerja sama dengan pihak lain (Pemerintah Daerah, swasta, lembaga dalam dan luar negeri), atau mandiri.&nbsp;
  </p>
  <p>
      <strong>5.1.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur pemerolehan, pengelolaan, dan penggunaan dana untuk kegiatan pendidikan, penelitian, dan PkM di UPPS.&nbsp;
  </p>
  <p>
      <strong>5.1.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      <strong>5.1.2.1 Pemerolehan Keuangan&nbsp;</strong>
  </p>
  <p>
      Tuliskan besar dana yang diperoleh oleh UPPS dalam tiga tahun terakhir, dengan mengikuti format Tabel 5.1.2.1.
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 5.1.2.1 Pemerolehan Dana]</u></strong></i>
  </p>
  <p>
      <strong>5.1.2.2 Penggunaan Dana&nbsp;</strong>
  </p>
  <p>
      Tuliskan jumlah dana yang digunakan oleh PS untuk keperluan kegiatan tridharma dalam tiga tahun terakhir, dengan mengikuti format Tabel 5.1.2.2
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 5.1.2.2 Penggunaan Dana]</u></strong></i>
  </p>
  <p>
      <strong>5.1.2.3 Dana Penelitian&nbsp;</strong>
  </p>
  <p>
      Tuliskan dana untuk kegiatan penelitian dalam tiga tahun terakhir yang dilakukan oleh DTPS yang bidang keahliannya sesuai dengan bidang PS, dengan mengikuti format Tabel 5.1.2.3.
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 5.1.2.3 Dana Penelitian]</u></strong></i>
  </p>
  <p>
      <strong>5.1.2.4 Dana PkM&nbsp;</strong>
  </p>
  <p>
      Tuliskan dana untuk kegiatan PkM dalam tiga tahun terakhir yang dilakukan oleh DTPS yang bidang keahliannya sesuai dengan bidang PS, dengan mengikuti format Tabel 5.1.2.4
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 5.1.2.4 Dana PkM]</u></strong></i>
  </p>
  <p>
      <strong>5.1.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap (1) kebijakan dan (2) pemerolehan, pengelolaan, dan penggunaan dana untuk kegiatan pendidikan, penelitian, dan PkM di PS dan UPPS.&nbsp;
  </p>
  <p>
      <strong>5.1.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 5.1.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan (1) jumlah dana yang diperoleh, (2) kualitas pengelolaan dana, dan (3) keefektifan penggunaan dana untuk kegiatan pendidikan, penelitian, dan PkM di PS dan UPPS.&nbsp;
  </p>
  <p>
      <strong>5.2 Prasarana dan Sarana Pendidikan&nbsp;</strong>
  </p>
  <p>
      Prasarana pendidikan adalah fasilitas yang bersifat tetap atau stabil, seperti lapangan, gedung kampus, ruang microteaching yang standar (wajib dimiliki), ruang kuliah, ruang laboratorium, dan auditorium atau aula, tempat ibadah yang berfungsi untuk menunjang pelaksanaan kegiatan pendidikan dan pembelajaran. Sarana pendidikan adalah fasilitas yang dapat dibawa atau dipindahkan dari satu tempat ke tempat lain (portable), seperti meja, kursi, laptop, LCD, dan referensi, yang berfungsi untuk menunjang pelaksanaan kegiatan pendidikan dan pembelajaran.
  </p>
  <p>
      <strong>5.2.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur pengelolaan dan pemanfaatan prasarana dan sarana pendidikan.&nbsp;
  </p>
  <p>
      <strong>5.2.2 Pelaksanaan</strong>
  </p>
  <p>
      <strong>5.2.2.1 Data Prasarana Pendidikan&nbsp;</strong>
  </p>
  <p>
      Tuliskan data prasarana pendidikan yang dapat diakses dan dipergunakan oleh PS untuk melaksanakan kegiatan pendidikan (perkuliahan, pembimbingan, ujian, seminar, lokakarya, dan lain-lain), dengan mengikuti format Tabel 5.2.2.1
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 5.2.2.1 Data Prasarana Pendidikan]</u></strong></i>
  </p>
  <p>
      <strong>5.2.2.2 Data Sarana Pendidikan&nbsp;</strong>
  </p>
  <p>
      Tuliskan data sarana pendidikan yang dapat diakses dan dipergunakan oleh PS untuk melaksanakan kegiatan pendidikan (perkuliahan, pembimbingan, ujian, seminar, lokakarya, dan lain-lain), dengan mengikuti format Tabel 5.2.2.2
  </p>
  <p>
      <i><strong><u>[Masukkan Tabel 5.2.2.2 Data Sarana Pendidikan]</u></strong></i>
  </p>
  <p>
      <strong>5.2.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pengadaan sarana pendidikan, yang meliputi jumlah, jenis, dan kualitas, serta pemanfaatan prasarana dan sarana pendidikan yang dapat diakses dan dipergunakan oleh PS untuk melaksanakan kegiatan pembelajaran: perkuliahan, pembimbingan, ujian, seminar, lokakarya, dan lain-lain.&nbsp;
  </p>
  <p>
      <strong>5.2.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 5.2.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan jumlah, jenis, kualitas, dan pemanfaatan prasarana dan sarana kegiatan pembelajaran: perkuliahan, pembimbingan, ujian, seminar, lokakarya, dan lain-lain
  </p>
  <p>
      &nbsp;
  </p>`
    },
    {
      id: 9,
      parent_id: 3,
      slug: 'kriteria-6-pendidikan',
      word_limits: 0,
      page_limits: 0,
      rules: [
          'keseluruhan kriteria (BAGIAN B KRITERIA) maksimal 180 halaman'
      ],
      content: `<p>
      <strong>KRITERIA 3. PENDIDIKAN</strong>
  </p><p>
      <strong>6.1 Kurikulum PS dan Perangkat Pembelajaran&nbsp;</strong>
  </p>
  <p>
      Kurikulum pendidikan tinggi adalah seperangkat rencana dan pengaturan mengenai isi, bahan kajian, dan bahan pelajaran serta cara penyampaiannya, dan penilaian yang digunakan sebagai pedoman penyelenggaraan kegiatan pembelajaran di perguruan tinggi. Dokumen kurikulum setidaknya berisi identitas PS; evaluasi terhadap pelaksanaan kurikulum sebelumnya; landasan pengembangan kurikulum; visi, misi, dan tujuan PS; profil lulusan, capaian pembelajaran lulusan (CPL); bidang kajian; daftar mata kuliah; dan perangkat pembelajaran. Kurikulum PS hendaknya mengakomodasi kebijakan Merdeka Belajar-Kampus Merdeka, yang memberi hak kepada mahasiswa untuk belajar di luar PS. Kurikulum yang baik adalah kurikulum yang lengkap unsurnya, tepat isinya, koheren antar unsur, relevan dengan bidang PS, dan mutakhir referensinya.&nbsp;
  </p>
  <p>
      <strong>6.1.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur perencanaan, penyusunan, pelaksanaan, penilaian, dan perbaikan kurikulum PS, yaitu kurikulum yang mengakomodasi kebijakan Merdeka Belajar-Kampus Merdeka.&nbsp;
  </p>
  <p>
      <strong>6.1.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      <strong>6.1.2.1 Kurikulum PS&nbsp;</strong>
  </p>
  <p>
      Tunjukkan dokumen kurikulum PS yang memuat aspek-aspek sebagai berikut: identitas PS; evaluasi terhadap pelaksanaan kurikulum sebelumnya; landasan pengembangan kurikulum; visi, misi, dan tujuan PS; profil lulusan; capaian pembelajaran lulusan (CPL); bidang kajian; daftar mata kuliah; dan perangkat pembelajaran. Kemukakan bagian dalam Kurikulum PS yang memberi hak kepada mahasiswa untuk belajar di luar PS (Kebijakan Merdeka Belajar-Kampus Merdeka).&nbsp;
  </p>
  <p>
      <strong>6.1.2.2 Mata Kuliah, CPL, dan Perangkat Pembelajaran&nbsp;</strong>
  </p>
  <p>
      Tuliskan mata kuliah beserta karakteristiknya (kode mata kuliah, jenis mata kuliah, bobot mata kuliah, dan unit penyelenggara), kesesuaiannya dengan CPL, dan ketersediaan perangkat pembelajaran, dengan mengikuti format Tabel 6.1.2.2
  </p>
  <p>
      <i><strong>[Masukkan Tabel 6.1.2.2 Mata Kuliah, CPL, dan Perangkat Pembelajaran]</strong></i>
  </p>
  <p>
      <strong>6.1.2.3 Dukungan UPPS terhadap Pengembangan Kurikulum PS&nbsp;</strong>
  </p>
  <p>
      Jelaskan dukungan UPPS terhadap pengembangan (perencanaan, penyusunan, pelaksanaan, pemantauan dan penilaian) kurikulum PS, disertai dengan dokumen yang relevan, seperti rencana strategis (renstra) dan rencana operasional (renop). Dukungan UPPS terhadap pengembangan kurikulum PS setidaknya berupa (1) pemberian dana, (2) penyediaan pakar yang relevan (seperti mengundang pakar dari luar PT atau berkoordinasi dengan lembaga atau unit terkait dalam PT), dan (3) pemberian asistensi (seperti penyelenggaraan lokakarya untuk menyamakan persepsi).&nbsp;
  </p>
  <p>
      <strong>6.1.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan pengembangan kurikulum dan kelengkapan kurikulum PS, serta dukungan UPPS terhadap pengembangan kurikulum PS.&nbsp;
  </p>
  <p>
      <strong>6.1.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 6.1.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan kualitas kurikulum PS.&nbsp;
  </p>
  <p>
      <strong>6.2 Pelaksanaan Pembelajaran&nbsp;</strong>
  </p>
  <p>
      Pelaksanaan pembelajaran mengacu pada kegiatan belajar-mengajar di dalam atau di luar kelas (baik secara tatap muka, virtual, atau bauran), baik di dalam PS maupun di luar PS, yang melibatkan interaksi dosen/fasilitator, mahasiswa, dan sumber belajar dalam lingkungan belajar tertentu, baik yang direncanakan maupun yang tidak direncanakan. Pembelajaran yang baik adalah pembelajaran yang sesuai dengan yang direncanakan dalam RPS dan memiliki sifat interaktif, holistik, integratif, saintifik, kontekstual, tematik, efektif, kolaboratif, dan berpusat pada mahasiswa, sebagaimana yang diamanatkan dalam SN-Dikti. Pembelajaran tersebut dapat dilaksanakan dengan cara tatap muka di dalam kampus atau secara virtual dengan memanfaatkan jaringan internet atau gabungan antara keduanya (blended learning). Pembelajaran diharapkan mengintegrasikan hasil penelitian dan/atau PkM, baik hasil penelitian/PkM sendiri maupun bersama mahasiswa. Integrasi hasil penelitian/PkM dapat dilihat antara lain dari digunakannya artikel hasil penelitian/PkM, buku ajar, dan modul sebagai referensi dan materi ajar. Untuk menjamin agar kegiatan pembelajaran berjalan dengan baik sesuai dengan yang direncanakan, UPPS dan/atau PT perlu memiliki sistem pemantauan yang handal, dan dilaksanakan secara periodik dan konsisten, dengan melibatkan gugus kendali mutu PS. Hasil pemantauan ditindaklanjuti dan disampaikan kepada pihak-pihak yang berkepentingan.&nbsp;
  </p>
  <p>
      <strong>6.2.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur pelaksanaan dan pemantauan pembelajaran, baik pembelajaran yang dilaksanakan di dalam maupun di luar PS.&nbsp;
  </p>
  <p>
      <strong>6.2.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      <strong>6.2.2.1 Pemenuhan Karakteristik Pembelajaran&nbsp;</strong>
  </p>
  <p>
      Jelaskan bagaimana PS dan UPPS memastikan bahwa pembelajaran yang dilakukan oleh DTPS sesuai dengan RPS yang telah disusun, dan memiliki sifat interaktif, holistik, integratif, saintifik, kontekstual, tematik, efektif, kolaboratif, dan berpusat pada mahasiswa, sebagaimana yang diamanatkan dalam SN-Dikti.&nbsp;
  </p>
  <p>
      <strong>6.2.2.2 Integrasi Hasil Penelitian dan PkM dalam Proses Pembelajaran&nbsp;</strong>
  </p>
  <p>
      Tuliskan judul penelitian atau PkM, nama dosen, nama mata kuliah, dan bentuk integrasi hasil penelitian dan/atau PkM dalam pembelajaran, dengan mengikuti format Tabel 6.2.2.2
  </p>
  <p>
      <i><strong>[Masukkan Tabel 6.2.2.2 Integrasi Hasil Penelitian dan PkM dalam Proses Pembelajaran]</strong></i>
  </p>
  <p>
      <strong>6.2.2.3 Sistem dan Pelaksanaan Pemantauan Kegiatan Pembelajaran&nbsp;</strong>
  </p>
  <p>
      Jelaskan bagaimana UPPS dan/atau PT membangun sistem yang handal dan teruji untuk memantau pelaksanaan pembelajaran (yang dilakukan oleh dosen) secara periodik dan konsisten, baik di dalam maupun di luar PS. Sertakan bukti yang relevan.&nbsp;
  </p>
  <p>
      <strong>6.2.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pelaksanaan &amp; pemantauan pembelajaran yang meliputi (a) pemenuhan karakteristik pembelajaran, (b) integrasi hasil penelitian dan PkM dalam proses pembelajaran, dan (c) sistem dan pelaksanaan pemantauan kegiatan pembelajaran.&nbsp;
  </p>
  <p>
      <strong>6.2.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 6.2.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan kualitas pelaksanaan dan pemantauan pembelajaran.
  </p>
  <p>
      <strong>6.3 Penilaian Pembelajaran&nbsp;</strong>
  </p>
  <p>
      Penilaian pembelajaran meliputi aspek sikap (attitude), pengetahuan (knowledge), dan keterampilan (skills). Dalam pelaksanaannya, penilaian tersebut dapat berupa assessment for learning (AfL) dan assessment of learning (AoL). AfL, yang sering disebut penilaian formatif (formative assessment), adalah penilaian untuk meningkatkan kualitas proses pembelajaran; sedangkan AoL, yang sering disebut dengan penilaian sumatif (summative assessment), adalah penilaian yang dilakukan untuk mengukur ketercapaian tujuan pembelajaran mahasiswa. Penilaian dapat memanfaatkan teknologi informasi dan komunikasi (TIK).&nbsp;
  </p>
  <p>
      <strong>6.3.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur penilaian pembelajaran di PS.&nbsp;
  </p>
  <p>
      <strong>6.3.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      Jelaskan bagaimana penilaian pembelajaran direncanakan, dilaksanakan, dan dievaluasi sebagai landasan untuk meningkatkan kualitas pembelajaran dalam rangka mewujudkan CPL yang telah ditetapkan dalam kurikulum.&nbsp;
  </p>
  <p>
      <strong>6.3.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pelaksanaan penilaian pembelajaran yang meliputi assessment for learning dan assessment of learning.&nbsp;
  </p>
  <p>
      <strong>6.3.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 6.3.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan kualitas pelaksanaan penilaian pembelajaran.&nbsp;
  </p>
  <p>
      <strong>6.4 Pembelajaran Mikro&nbsp;</strong>
  </p>
  <p>
      Pembelajaran mikro (micro-teaching) adalah pembelajaran yang dilakukan untuk mengembangkan keterampilan mengajar secara terpisah (discrete), seperti (1) membuka dan menutup pelajaran, (2) menjelaskan, (3) bertanya, (4) melakukan variasi, (5) memberikan penguatan (reinforcement), (6) mengelola kelas, (7) membimbing diskusi, dan (8) mengajar kelompok kecil dan perseorangan. Pembelajaran mikro merupakan mata kuliah praktikum yang menjembatani mata kuliah teori dan mata kuliah praktik.&nbsp;
  </p>
  <p>
      <strong>6.4.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur pembelajaran mikro di PS.&nbsp;
  </p>
  <p>
      <strong>6.4.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      Jelaskan bagaimana pembelajaran mikro direncanakan, dilaksanakan, dievaluasi, dan ditindaklanjuti sehingga mampu mengembangkan keterampilan mengajar mahasiswa (calon pendidik) sebagai bekal untuk melakukan praktik mengajar di sekolah mitra.&nbsp;
  </p>
  <p>
      <strong>6.4.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pelaksanaan pembelajaran mikro di PS.&nbsp;
  </p>
  <p>
      <strong>6.4.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 6.4.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan kualitas pelaksanaan pembelajaran mikro di PS. '
  </p>
  <p>
      <strong>6.5 Pembimbingan Mahasiswa&nbsp;</strong>
  </p>
  <p>
      Pembimbingan mahasiswa adalah kegiatan pemberian bantuan dan/atau arahan kepada mahasiswa untuk mengerjakan atau menyelesaikan suatu pekerjaan tertentu, seperti kuliah, magang kependidikan, dan penulisan skripsi atau penyelesaian tugas akhir, sehingga mahasiswa dapat mencapai hasil yang maksimal.&nbsp;
  </p>
  <p>
      <strong>6.5.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur pembimbingan mahasiswa, yang meliputi (a) pembimbingan akademik, (b) Pembimbingan magang kependidikan, dan (c) Pembimbingan tugas akhir atau skripsi.&nbsp;
  </p>
  <p>
      <strong>6.5.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      <strong>6.5.2.1 Pembimbingan Akademik&nbsp;</strong>
  </p>
  <p>
      Pembimbingan akademik adalah pembimbingan yang diberikan oleh dosen pembimbing akademik (PA) kepada mahasiswa bimbingannya terkait dengan perkuliahan, seperti pengambilan mata kuliah dan cara belajar yang efektif. Jelaskan proses pembimbingan akademik yang dilakukan oleh PA terhadap mahasiswa yang dibimbingnya, dengan mengikuti format Tabel 6.5.2.1.
  </p>
  <p>
      <i><strong>[Masukkan Tabel 6.5.2.1 Proses Pembimbingan Akademik]</strong></i>
  </p>
  <p>
      <strong>6.5.2.2 Jumlah Mahasiswa Bimbingan dan Frekuensi Pertemuan&nbsp;</strong>
  </p>
  <p>
      Tuliskan nama dosen pembimbing akademik (PA), jumlah mahasiswa yang dibimbing, dan banyaknya pertemuan pembimbingan dalam satu semester, dengan mengikuti format Tabel 6.5.2.2.
  </p>
  <p>
      <i><strong>[Masukkan Tabel 6.5.2.2 Jumlah Mahasiswa Bimbingan dan Frekuensi Pertemuan]</strong></i>
  </p>
  <p>
      <strong>6.5.2.3 Pembimbingan Magang Kependidikan&nbsp;</strong>
  </p>
  <p>
      Pembimbingan magang kependidikan adalah pembimbingan yang diberikan oleh dosen kepada mahasiswa bimbingannya terkait dengan kegiatan pengenalan persekolahan dan praktik mengajar di sekolah mitra (PAUD, TK, SD, SMP, SMA, SMK, dan yang sejenis). Pembimbingan dilakukan bersama-sama dengan guru setempat, yang dalam praktiknya dapat dilakukan secara tatap muka, virtual, atau bauran (blended).&nbsp;
  </p>
  <p>
      Jelaskan proses pembimbingan magang kependidikan yang dilakukan oleh dosen pembimbing magang terhadap mahasiswa yang dibimbingnya, dengan mengikuti format Tabel 6.5.2.3.
  </p>
  <p>
      <i><strong>[Masukkan Tabel 6.5.2.3 Proses Pembimbingan Magang Kependidikan]</strong></i>
  </p>
  <p>
      <strong>6.5.2.4 Jumlah Mahasiswa Bimbingan Magang Kependidikan dan Frekuensi Pertemuan&nbsp;</strong>
  </p>
  <p>
      Tuliskan nama dosen pembimbing magang kependidikan, jumlah mahasiswa yang dibimbing, dan banyaknya pertemuan pembimbingan dalam satu periode magang, dengan mengikuti format Tabel 6.5.2.4
  </p>
  <p>
      <i><strong>[Masukkan Tabel Tabel 6.5.2.4 Jumlah Mahasiswa Bimbingan Magang Kependidikan dan Frekuensi Pertemuan]</strong></i>
  </p>
  <p>
      <strong>6.5.2.5 Pembimbingan Tugas Akhir atau Skripsi.&nbsp;</strong>
  </p>
  <p>
      Pembimbingan tugas akhir atau skripsi adalah pembimbingan yang diberikan oleh dosen pembimbing tugas akhir atau skripsi kepada mahasiswa yang dibimbingnya, baik secara tatap muka, virtual, maupun bauran, yang terdokumentasi dengan baik.&nbsp;
  </p>
  <p>
      Jelaskan proses pembimbingan tugas akhir atau skripsi yang dilakukan oleh dosen pembimbing kepada mahasiswa yang dibimbingnya, dengan mengikuti format Tabel 6.5.2.5.
  </p>
  <p>
      <i><strong>[Masukkan Tabel 6.5.2.5 Proses Pembimbingan Tugas Akhir atau Skripsi]</strong></i>
  </p>
  <p>
      <strong>6.5.2.6 Jumlah Mahasiswa Bimbingan Tugas Akhir atau Skripsi dan Frekuensi Pertemuan&nbsp;</strong>
  </p>
  <p>
      Tuliskan nama dosen pembimbing tugas akhir atau skripsi jumlah mahasiswa yang dibimbing, dan banyaknya pertemuan pembimbingan, dengan mengikuti format Tabel 6.5.2.6.
  </p>
  <p>
      <i><strong>[Masukkan Tabel 6.5.2.6 Jumlah Mahasiswa Bimbingan Tugas Akhir atau Skripsi dan Frekuensi Pertemuan]</strong></i>
  </p>
  <p>
      <strong>6.5.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pelaksanaan pembimbingan mahasiswa, yang meliputi pembimbingan akademik, pembimbingan magang kependidikan, dan pembimbingan tugas akhir atau skripsi.&nbsp;
  </p>
  <p>
      <strong>6.5.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 6.5.4, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan kualitas pelaksanaan pembimbingan akademik, pembimbingan magang kependidikan, dan pembimbingan tugas akhir atau skripsi.&nbsp;
  </p>
  <p>
      <strong>6.6 Suasana Akademik&nbsp;</strong>
  </p>
  <p>
      <strong>6.6.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur suasana akademik yang meliputi kegiatan akademik di luar perkuliahan dan dosen tamu/tenaga ahli. 38&nbsp;
  </p>
  <p>
      <strong>6.6.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      <strong>6.6.2.1 Kegiatan Akademik di Luar Perkuliahan&nbsp;</strong>
  </p>
  <p>
      Tuliskan kegiatan akademik di luar perkuliahan, seperti konferensi, seminar, lokakarya, pelatihan, bedah buku, dan pertukaran mahasiswa, dengan mengikuti format Tabel 6.6.2.1.
  </p>
  <p>
      <i><strong>[Masukkan Tabel 6.6.2.1 Kegiatan Akademik di Luar Perkuliahan]</strong></i>
  </p>
  <p>
      <strong>6.6.2.2 Dosen Tamu dan Tenaga Ahli&nbsp;</strong>
  </p>
  <p>
      Dosen tamu adalah dosen di luar PT yang mengajar di PS paling sedikit delapan kali pertemuan dan memberi nilai kepada mahasiswa. Tenaga ahli adalah pakar atau praktisi (termasuk guru sekolah mitra/laboratorium) yang mengisi kegiatan di PS, seperti kuliah umum, seminar, lokakarya, dan pelatihan.&nbsp;
  </p>
  <p>
      Tuliskan nama dosen tamu atau tenaga ahli, nama lembaga, kepakaran/bidang keahlian, mata kuliah, waktu kegiatan, dan bukti kegiatan dengan mengikuti format Tabel 6.6.2.2
  </p>
  <p>
      <i><strong>[Masukkan Tabel 6.6.2.2 Dosen Tamu dan Tenaga Ahli]</strong></i>
  </p>
  <p>
      <strong>6.6.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pelaksanaan kegiatan akademik di luar perkuliahan dan dosen tamu/tenaga ahli.&nbsp;
  </p>
  <p>
      <strong>6.6.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 6.6.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan kualitas pelaksanaan kegiatan akademik di luar perkuliahan dan dosen tamu/tenaga ahli.&nbsp;
  </p>
  <p>
      <strong>6.7 Kepuasan Mahasiswa&nbsp;</strong>
  </p>
  <p>
      Kepuasan mahasiswa adalah tingkat perasaan mahasiswa setelah membandingkan antara apa yang mereka harapkan dan apa yang mereka temui atau terima. Kepuasan mahasiswa difokuskan pada tiga hal, yaitu performa mengajar dosen, layanan administrasi akademik, dan penyediaan prasarana dan sarana pembelajaran. Pengukuran kepuasan mahasiswa terhadap tiga objek tersebut dilihat dari enam aspek sebagai berikut: (1) menggunakan instrumen kepuasan yang sahih dan mudah digunakan, (2) dilaksanakan di setiap akhir semester dan datanya terekam secara lengkap, (3) hasilnya dianalisis dengan metode yang tepat dan bermanfaat untuk pengambilan keputusan, (4) dilakukan review terhadap hasil pelaksanaan pengukuran kepuasan, (5) ditindaklanjuti untuk perbaikan dan peningkatan mutu pengajaran, dan (6) hasilnya dipublikasikan dan mudah diakses pihak-pihak yang berkepentingan.&nbsp;
  </p>
  <p>
      <strong>6.7.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur kepuasan mahasiswa terhadap kinerja mengajar dosen, layanan administrasi akademik, dan prasarana/sarana pembelajaran.&nbsp;
  </p>
  <p>
      <strong>6.7.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      Beri tanda centang (√) pada kolom Tabel 6.7.2 yang sesuai dengan realitas.
  </p>
  <p>
      <i><strong>[Masukkan Tabel 6.7.2 Kepuasan Mahasiswa]</strong></i>
  </p>
  <p>
      <strong>6.7.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi tentang kebijakan dan tingkat kepuasan mahasiswa terhadap kinerja mengajar dosen, layanan administrasi akademik, dan prasarana/sarana pembelajaran.&nbsp;
  </p>
  <p>
      <strong>6.7.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 6.7.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan tingkat kepuasan mahasiswa terhadap kinerja mengajar dosen, layanan administrasi akademik, dan prasarana/sarana pembelajaran
  </p>`
    },
    {
      id: 10,
      parent_id: 3,
      slug: 'kriteria-7-penelitian',
      word_limits: 0,
      page_limits: 0,
      rules: [
          'keseluruhan kriteria (BAGIAN B KRITERIA) maksimal 180 halaman'
      ],
      content: `<p>
      <strong>KRITERIA 7. PENELITIAN</strong>
  </p><p>
      Peta Jalan (roadmap) penelitian merupakan milestone kegiatan penelitian dalam kurun waktu tertentu (seperti 5 sampai dengan 10 tahun) yang dilakukan oleh peneliti (monodisiplin) dan/atau oleh kelompok peneliti (dalam kelompok penelitian atau research group), baik secara multidisipliner atau intra/interdisipliner. Peta jalan penelitian mencakup kegiatan penelitian yang telah dilakukan oleh peneliti beberapa tahun sebelumnya dalam topik tertentu; penelitian yang sedang dilakukan dalam topik yang sama; dan penelitian yang akan dilakukan ke depan, juga dalam topik yang sama. Penelitian-penelitian tersebut membentuk mata rantai yang koheren sebagai sebuah keutuhan, yang menggambarkan research interest dan sekaligus kepakaran (expertise) peneliti. Kelompok peneliti (research group), yang beranggotakan dosen-dosen dari PS yang sama atau dari PS yang berbeda dalam suatu UPPS atau dari PS yang berbeda dalam UPPS yang berbeda dalam satu PT, meneliti topik yang sama, bekerja secara bersama dalam sebuah tim.&nbsp;
  </p>
  <p>
      <strong>7.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur penelitian di PS dan UPPS.&nbsp;
  </p>
  <p>
      <strong>7.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      <strong>7.2.1 Peta Jalan dan Kelompok Penelitian&nbsp;</strong>
  </p>
  <p>
      Deskripsikan pelaksanaan penelitian DTPS yang dilakukan berdasarkan pada peta jalan (roadmap) dan kelompok penelitian (research group).&nbsp;
  </p>
  <p>
      <strong>7.2.2 Aktivitas, Relevansi, dan Pelibatan Mahasiswa dalam Penelitian&nbsp;</strong>
  </p>
  <p>
      Aktivitas penelitian mengacu pada banyaknya kegiatan penelitian yang dilakukan oleh DTPS dalam satu tahun. Relevansi penelitian mengacu pada keterkaitan topik penelitian dengan keahlian atau kepakaran peneliti (DTPS) dan VMTS PS. Pelibatan mahasiswa dalam penelitian mengacu pada partisipasi mahasiswa dalam kegiatan penelitian yang dilakukan oleh DTPS, mulai dari penyusunan proposal, pengkajian teori yang relevan, pengumpulan data, analisis data, penyusunan laporan penelitian, sampai dengan penulisan artikel hasil penelitian untuk diterbitkan. Tuliskan aktivitas karya penelitiaan yang relevan dan yang melibatkan mahasasiswa yang dilakukan oleh DTPS dalam tiga tahun terakhir, dengan mengikuti format Tabel 7.2.2
  </p>
  <p>
      <i><strong>[Masukkan Tabel 7.2.2 Aktivitas, Relevansi, dan Pelibatan Mahasiswa dalam Penelitian]</strong></i>
  </p>
  <p>
      <strong>7.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pelaksanaan penelitian yang dilakukan oleh DTPS berdasarkan pada peta jalan (roadmap) penelitian yang telah dibuat: produktivitas, relevansi, dan pelibatan mahasiswa dalam penelitian dosen.&nbsp;
  </p>
  <p>
      <strong>7.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 7.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan produktivitas, relevansi, dan pelibatan mahasiswa dalam penelitian dosen.
  </p>`
    },
    {
      id: 11,
      parent_id: 3,
      slug: 'kriteria-8-pengabdian-kepada-masyarakat',
      word_limits: 0,
      page_limits: 0,
      rules: [
          'keseluruhan kriteria (BAGIAN B KRITERIA) maksimal 180 halaman'
      ],
      content: `<p>
      <strong>KRITERIA 3. PENGABDIAN KEPADA MASYARAKAT</strong>
  </p><p>
      <strong>KRITERIA 8. PENGABDIAN KEPADA MASYARAKAT</strong>
  </p>
  <p>
      Peta jalan PkM merupakan milestone kegiatan PkM dalam kurun waktu tertentu (seperti 5 sampai dengan 10 tahun) yang dilakukan oleh pengabdi (mono disiplin) dan/atau oleh kelompok PkM, baik secara multidisipliner atau intra/inter-disipliner. Peta jalan PkM mencakup kegiatan PkM yang telah dilakukan oleh pengabdi beberapa tahun sebelumnya dalam topik tertentu; PkM yang sedang dilakukan dalam topik yang sama; dan PkM yang akan dilakukan ke depan, juga dalam topik yang sama. PkM tersebut membentuk mata rantai yang koheren sebagai sebuah keutuhan.&nbsp;
  </p>
  <p>
      <strong>8.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur PkM di PS dan UPPS.&nbsp;
  </p>
  <p>
      <strong>8.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      <strong>8.2.1 Peta Jalan dan Kelompok PkM</strong>
  </p>
  <p>
      Deskripsikan pelaksanaan kegiatan PkM DTPS yang dilakukan berdasarkan pada peta jalan (roadmap) PkM.&nbsp;
  </p>
  <p>
      <strong>8.2.2 Aktivitas, Relevansi, dan Pelibatan Mahasiswa dalam PkM&nbsp;</strong>
  </p>
  <p>
      Aktivitas PkM mengacu pada banyaknya kegiatan PkM yang dilakukan oleh DTPS dalam satu tahun. Relevansi PkM mengacu pada keterkaitan topik PkM dengan keahlian atau kepakaran peneliti (DTPS) dan VMTS PS. Pelibatan mahasiswa dalam PkM mengacu pada partisipasi mahasiswa dalam kegiatan PkM yang dilakukan oleh DTPS, mulai dari penyusunan proposal, pengkajian teori yang relevan, pengumpulan data, analisis data, penyusunan laporan PkM, sampai dengan penulisan artikel hasil PkM untuk diterbitkan. Tuliskan aktivitas PkM yang relevan dan yang melibatkan mahasasiswa yang dilakukan oleh DTPS dalam tiga tahun terakhir, dengan mengikuti format Tabel 8.2.2
  </p>
  <p>
      <i><strong>[Masukkan Tabel 8.2.2 Aktivitas, Relevansi, dan Pelibatan Mahasasiswa dalam PkM]</strong></i>
  </p>
  <p>
      <strong>8.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan pelaksanaan PkM yang dilakukan oleh DTPS berdasarkan pada peta jalan (roadmap) penelitian yang telah dibuat: produktivitas, relevansi, dan pelibatan mahasiswa dalam kegiatan PkM dosen.&nbsp;
  </p>
  <p>
      <strong>8.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 8.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan produktivitas, relevansi, dan pelibatan mahasiswa dalam kegiatan PkM dosen.
  </p>`
    },
    {
      id: 12,
      parent_id: 3,
      slug: 'kriteria-9-keluaran-dan-capaian-tridharma',
      word_limits: 0,
      page_limits: 0,
      rules: [
          'keseluruhan kriteria (BAGIAN B KRITERIA) maksimal 180 halaman'
      ],
      content: `<p>
      <strong>KRITERIA 9. KELUARAN DAN CAPAIAN TRIDHARMA</strong>
  </p>
  <p>
      <strong>9.1 Keluaran dan Capaian Dharma Pendidikan&nbsp;</strong>
  </p>
  <p>
      Keluaran dan capaian dharma pendidikan meliputi IPK lulusan, prestasi mahasiswa (akademik dan non-akademik), masa studi, kelulusan tepat waktu, keberhasilan studi, tracer study, waktu tunggu, relevansi bidang pekerjaan, dan tingkat kepuasan pengguna lulusan.&nbsp;
  </p>
  <p>
      <strong>9.1.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur keluaran dan capaian dharma pendidikan, yang meliputi IPK lulusan, prestasi mahasiswa (akademik dan non-akademik), masa studi, kelulusan tepat waktu, keberhasilan studi, tracer study, waktu tunggu, relevansi bidang pekerjaan, dan tingkat kepuasan pengguna lulusan.
  </p>
  <p>
      <strong>9.1.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      <strong>9.1.2.1 IPK Lulusan&nbsp;</strong>
  </p>
  <p>
      Tuliskan data jumlah lulusan dan indeks prestasi kumulatif (IPK) mereka dalam tiga tahun terakhir, dengan mengikuti format Tabel 9.1.2.1.
  </p>
  <p>
      <i><strong>[Masukkan Tabel 9.1.2.1 IPK Lulusan]</strong></i>
  </p>
  <p>
      <strong>9.1.2.2 Prestasi Mahasiswa&nbsp;</strong>
  </p>
  <p>
      Tuliskan data prestasi akademik (seperti menjadi pemenang atau juara 1, 2, 3, atau harapan dalam lomba karya tulis ilmiah, kegiatan olimpiade ilmiah, debat, pengembangan model, dan lain-lain) dan prestasi non-akademik (seperti bidang olah raga, seni, pramuka, dan kesehatan) dalam tiga tahun terakhir, dengan mengikuti format Table 9.1.2.2
  </p>
  <p>
      <i><strong>[Masukkan Tabel 9.1.2.2 Prestasi Mahasiswa]</strong></i>
  </p>
  <p>
      <strong>9.1.2.3 Masa Studi, Kelulusan Tepat Waktu, dan Keberhasilan Studi&nbsp;</strong>
  </p>
  <p>
      Tuliskan data tentang masa studi, kelulusan tepat waktu, dan keberhasilan studi mahasiswa, dengan mengikuti format Tabel 9.1.2.3
  </p>
  <p>
      <i><strong>[Masukkan Tabel 9.1.2.3 Masa Studi, Kelulusan Tepat Waktu, dan Keberhasilan Studi]</strong></i>
  </p>
  <p>
      <strong>9.1.2.4 Tracer Study, Waktu Tunggu Mendapatkan Pekerjaan Pertama&nbsp;</strong>
  </p>
  <p>
      Tuliskan data tentang hasil pelacakan lulusan (tracer study), jumlah lulusan yang terlacak, dan waktu tunggu mendapatkan pekerjaan pertama, dengan mengikuti format Tabel 9.1.2.4.
  </p>
  <p>
      <i><strong>[Masukkan Tabel 9.1.2.4 Tracer Study, Waktu Tunggu Mendapatkan Pekerjaan Pertama]</strong></i>
  </p>
  <p>
      <strong>9.1.2.5 Tingkat Relevansi Pekerjaan&nbsp;</strong>
  </p>
  <p>
      Tuliskan data tentang jumlah lulusan, jumlah lulusan yang terlacak, dan jumlah lulusan terlacak dengan tingkat relevansi bidang kerja mereka (yaitu bidang kependidikan dalam arti luas: guru, instruktur, pelatih, penyuluh, pengelola kursus, perancang pelatihan, pengembang kurikulum, perancang program pembelajaran, dan lain-lain), dengan mengikuti format Tabel 9.1.2.5.
  </p>
  <p>
      <i><strong>[Masukkan Tabel 9.1.2.5 Tingkat Relevansi Pekerjaan]</strong></i>
  </p>
  <p>
      <strong>9.1.2.6 Tingkat Kepuasan Pengguna Lulusan&nbsp;</strong>
  </p>
  <p>
      Tuliskan data tentang tingkat kepuasan pengguna terkait dengan tujuh jenis kemampuan yang ditunjukkan oleh lulusan, dengan mengikuti format Tabel 9.1.2.6.
  </p>
  <p>
      <i><strong>[Masukkan Tabel 9.1.2.6 Tingkat Kepuasan Pengguna Lulusan]</strong></i>
  </p>
  <p>
      <strong>9.1.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan realisasi dari keluaran dan capaian dharma pendidikan yang meliputi IPK lulusan, prestasi mahasiswa, masa studi, kelulusan tepat waktu, keberhasilan studi, tracer study, waktu tunggu, relevansi bidang pekerjaan, dan tingkat kepuasan pengguna lulusan. 50&nbsp;
  </p>
  <p>
      <strong>9.1.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 9.1.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan jumlah dan kualitas keluaran dan capaian dharma pendidikan yang meliputi IPK lulusan, prestasi mahasiswa, masa studi, kelulusan tepat waktu, keberhasilan studi, tracer study, waktu tunggu, relevansi bidang pekerjaan, dan tingkat kepuasan pengguna lulusan.&nbsp;
  </p>
  <p>
      <strong>9.2 Keluaran dan Capaian Dharma Penelitian dan PkM&nbsp;</strong>
  </p>
  <p>
      <strong>9.2.1 Kebijakan&nbsp;</strong>
  </p>
  <p>
      Kemukakan kebijakan tertulis dalam bentuk peraturan perundang-undangan (Undang-Undang, Peraturan Pemerintah, Peraturan Menteri, dan lain-lain) dan/atau peraturan pimpinan perguruan tinggi (Rektor, Direktur, atau Ketua) yang mengatur keluaran dan capaian dharma penelitian dan PkM dosen dan mahasiswa, yang meliputi publikasi, karya ilmiah yang disitasi, produk atau jasa yang diadopsi oleh masyarakat, dan produk atau jasa yang ber-HKI atau paten.&nbsp;
  </p>
  <p>
      <strong>9.2.2 Pelaksanaan&nbsp;</strong>
  </p>
  <p>
      <strong>9.2.2.1 Publikasi DTPS dan Mahasiswa&nbsp;</strong>
  </p>
  <p>
      Tuliskan data publikasi hasil penelitian, PkM, dan/atau pemikiran DTPS (dan mahasiswa yang dibimbingnya) yang bidang keahliannya sesuai dengan bidang PS dalam tiga tahun terakhir, dengan mengikuti format Tabel 9.2.2.1
  </p>
  <p>
      <i><strong>[Masukkan Tabel 9.2.2.1 Publikasi DTPS dan Mahasiswa]</strong></i>
  </p>
  <p>
      <strong>9.2.2.2 Karya Ilmiah DTPS dan Mahasiswa yang Disitasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan data karya ilmiah hasil penelitian, PkM, dan/atau pemikiran (judul karya ilmiah, tahun, nama jurnal/prosiding/buku, nomor halaman) DTPS (dan mahasiswa yang dibimbingnya) yang bidang keahliannya sesuai dengan bidang PS dalam tiga tahun terakhir, dengan mengikuti format Tabel 9.2.2.2
  </p>
  <p>
      <i><strong>[Masukkan Tabel 9.2.2.2 Karya Ilmiah DTPS dan Mahasiswa yang Disitasi]</strong></i>
  </p>
  <p>
      <strong>9.2.2.3 Produk atau Jasa DTPS dan Mahasiswa yang Diadopsi oleh Masyarakat&nbsp;</strong>
  </p>
  <p>
      Tuliskan data produk atau jasa hasil penelitian, PkM, dan/atau pemikiran DTPS (dan mahasiswa yang dibimbingnya) yang bidang keahliannya sesuai dengan bidang PS dalam tiga tahun terakhir yang telah diadopsi oleh masyarakat, dengan mengikuti format Table 9.2.2.3.
  </p>
  <p>
      <i><strong>[Masukkan Tabel 9.2.2.3 Produk atau Jasa DTPS dan Mahasiswa yang Diadopsi oleh Masyarakat]</strong></i>
  </p>
  <p>
      <strong>9.2.2.4 Produk atau Jasa DTPS dan Mahasiswa yang Ber-HKI atau Paten&nbsp;</strong>
  </p>
  <p>
      Tuliskan data produk atau jasa hasil penelitian, PkM, dan/atau pemikiran DTPS (dan mahasiswa yang dibimbingnya) yang bidang keahliannya sesuai dengan bidang PS dalam tiga tahun terakhir yang sudah memiliki HKI atau paten, dengan mengikuti format Tabel 9.2.2.4.
  </p>
  <p>
      <i><strong>[Masukkan Tabel 9.2.2.4 Produk atau Jasa DTPS dan Mahasiswa yang Ber-HKI atau Paten]</strong></i>
  </p>
  <p>
      <strong>9.2.3 Evaluasi&nbsp;</strong>
  </p>
  <p>
      Tuliskan hasil evaluasi terhadap kebijakan dan keluaran dan capaian dharma penelitian dan PkM dosen dan mahasiswa, yang meliputi publikasi, karya ilmiah yang disitasi, produk atau jasa yang diadopsi oleh masyarakat, dan produk atau jasa yang ber-HKI atau paten.&nbsp;
  </p>
  <p>
      <strong>9.2.4 Tindak Lanjut&nbsp;</strong>
  </p>
  <p>
      Berdasarkan hasil evaluasi sebagaimana tertuang dalam butir 9.2.3, jelaskan tindak lanjut yang telah diambil oleh UPPS dalam rangka meningkatkan jumlah dan kualitas luaran dan capaian dharma penelitian dan PkM dosen dan mahasiswa, yang meliputi publikasi, karya ilmiah yang disitasi, produk atau jasa yang diadopsi oleh masyarakat, dan produk atau jasa yang ber-HKI atau paten
  </p>`
    },
    {
      id: 13,
      slug: 'bagian-c-analisis-permasalahan-dan-pengembangan-program-studi',
      word_limits: 0,
      page_limits: 10,
      rules: [
          'Maksimal 10 halaman'
      ],
      content: `<h2 style="text-align:center;">
      <strong>BAGIAN C</strong>
  </h2>
  <h2 style="text-align:center;">
      <strong>ANALISIS PERMASALAHAN DAN PENGEMBANGAN PROGRAM STUDI</strong>
  </h2><p style="text-align:center;">
  &nbsp;
  </p><p>
      Bertitik tolak dari hasil deskripsi data kualitatif &amp; data kuantitatif, analisis &amp; evaluasi, dan tindak lanjut yang disajikan di Bagian B (Kriteria), UPPS melakukan evaluasi capaian kinerja secara komprehensif untuk mengetahui apakah semua program kerja yang telah direncanakan dan dituangkan dalam rencana strategis dan rencana tahunan sudah dapat dicapai. Di samping itu, secara lebih spesifik, UPPS melakukan analisis kritis terhadap eksistensi PS dengan cara mengidentifikasi kelebihan dan kelemahannya berdasarkan pada parameter tertentu (seperti SNDikti, peraturan-peraturan yang relevan, atau standar lainnya yang melampaui SN-Dikti) atau berdasarkan pada posisinya di antara PS sejenis di luar perguruan tinggi. Dengan analisis kritis tersebut diharapkan UPPS dapat mengidentifikasi permasalahan dan tantangan yang dihadapi oleh PS dan sekaligus pemecahannya. Selanjutnya, UPPS diharapkan mampu menetapkan sasaran dan setrategi pengembangan PS yang tepat sesuai dengan kapasitas yang dimilikinya, kebutuhan PS, dan perkembangan IPTEKS mutakhir.&nbsp;
  </p>
  <p>
      <strong>C.1 Evaluasi Capaian Kinerja PS&nbsp;</strong>
  </p>
  <p>
      Uraikan (1) pelaksanaan evaluasi capaian kinerja PS: waktu pelaksanaan, mekanisme, dan pihakpihak yang terlibat; (2) hasil evaluasi capaian kinerja: keberhasilan dan ketidakberhasilan, dan (3) tindak lanjut.&nbsp;
  </p>
  <p>
      <strong>C2. Permasalahan dan Pemecahan Praktis&nbsp;</strong>
  </p>
  <p>
      Uraikan permasalahan yang dihadapi oleh PS yang mencakup (1) tata pamong, tata kelola, dan kerjasama; (2) mahasiswa; (3) sumber daya manusia; (4) keuangan, sarana dan prasarana; (5) pendidikan; (6) penelitian; (7) pengabdian kepada masyarakat; dan (8) luaran dan capaian tridharma, dengan mengikuti format Tabel C.2.
  </p>
  <p>
      Tabel C2. Permasalahan dan Pemecahan Praktis
  </p>
  <figure class="table">
      <table>
          <thead>
              <tr>
                  <th>
                      <p style="text-align:center;">
                          No
                      </p>
                  </th>
                  <th>
                      <p style="text-align:center;">
                          Permasalahan
                      </p>
                  </th>
                  <th>
                      <p style="text-align:center;">
                          Pemecahan Praktis
                      </p>
                  </th>
              </tr>
              <tr>
                  <th>
                      <p style="text-align:center;">
                          (1)
                      </p>
                  </th>
                  <th>
                      <p style="text-align:center;">
                          (2)
                      </p>
                  </th>
                  <th>
                      <p style="text-align:center;">
                          (3)
                      </p>
                  </th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td>
                      <p style="text-align:center;">
                          1
                      </p>
                  </td>
                  <td>
                      <p style="text-align:center;">
                          &nbsp;
                      </p>
                  </td>
                  <td>
                      <p style="text-align:center;">
                          &nbsp;
                      </p>
                  </td>
              </tr>
              <tr>
                  <td>
                      <p style="text-align:center;">
                          dst
                      </p>
                  </td>
                  <td>
                      <p style="text-align:center;">
                          &nbsp;
                      </p>
                  </td>
                  <td>
                      <p style="text-align:center;">
                          &nbsp;
                      </p>
                  </td>
              </tr>
          </tbody>
      </table>
  </figure>
  <p>
      <strong>C.3 Program Pengembangan&nbsp;</strong>
  </p>
  <p>
      Uraikan program pengembangan PS yang mencakup (1) tata pamong, tata kelola, dan kerjasama; (2) mahasiswa; (3) sumber daya manusia; (4) keuangan, sarana dan prasarana; (5) pendidikan; (6) penelitian; (7) pengabdian kepada masyarakat; dan (8) luaran dan capaian tridharma,
  </p>`
    },
  ]